/** @file Skeleton-space bounding box of the viewport (the four pixel corners through the inverse camera). */
import { affine } from '@pose2d/math/affine';
import type { Sink } from '../draw/createSink';

const p: [number, number] = [0, 0];

/** Writes [minX, minY, maxX, maxY] of the visible world area into `out` (corners (0,0), (w,0), (w,h), (0,h)). */
export function visibleWorldBox(sink: Sink, out: [number, number, number, number]): [number, number, number, number] {
  out[0] = Infinity;
  out[1] = Infinity;
  out[2] = -Infinity;
  out[3] = -Infinity;
  for (let i = 0; i < 4; i++) {
    affine.apply(sink.toWorld, i === 1 || i === 2 ? sink.width : 0, i >= 2 ? sink.height : 0, p);
    out[0] = Math.min(out[0], p[0]);
    out[1] = Math.min(out[1], p[1]);
    out[2] = Math.max(out[2], p[0]);
    out[3] = Math.max(out[3], p[1]);
  }
  return out;
}
